<template>
   <div class="animation-box" ref="animationContainer">
        <transition-group name="flying-heart" tag="div" v-on:after-enter="enterLikeTransition">
            <div
                v-for="(likeAnimation, indexAnimation) in listRenderAnimations"
                :class="`flying-heart ${likeAnimation.animationClass} ${likeAnimation.bgClassAnimation}`"
                v-bind:key="likeAnimation.index"
                v-bind:data-index="indexAnimation"
            >
            <svg width="75" height="70" viewBox="0 0 75 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                <mask id="path-1-outside-1" maskUnits="userSpaceOnUse" x="0.917114" y="0.5" width="74" height="70" fill="black">
                    <rect fill="white" x="0.917114" y="0.5" width="74" height="70"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M72.9171 21.4575C72.9171 10.99 64.4796 2.5 54.0721 2.5C47.2021 2.5 41.2096 6.2075 37.9171 11.73C34.6246 6.2075 28.6321 2.5 21.7621 2.5C11.3546 2.5 2.91711 10.99 2.91711 21.4575C2.91711 45.8325 37.9171 67.5 37.9171 67.5C37.9171 67.5 72.9171 45.8325 72.9171 21.4575Z"/>
                </mask>
                <path id="solid" fill-rule="evenodd" clip-rule="evenodd" d="M72.9171 21.4575C72.9171 10.99 64.4796 2.5 54.0721 2.5C47.2021 2.5 41.2096 6.2075 37.9171 11.73C34.6246 6.2075 28.6321 2.5 21.7621 2.5C11.3546 2.5 2.91711 10.99 2.91711 21.4575C2.91711 45.8325 37.9171 67.5 37.9171 67.5C37.9171 67.5 72.9171 45.8325 72.9171 21.4575Z" fill="#FF9900"/>
                <path d="M37.9171 11.73L36.1993 12.7542L37.9171 15.6355L39.635 12.7542L37.9171 11.73ZM37.9171 67.5L36.8644 69.2005L37.9171 69.8522L38.9699 69.2005L37.9171 67.5ZM74.9171 21.4575C74.9171 9.89682 65.5955 0.5 54.0721 0.5V4.5C63.3637 4.5 70.9171 12.0832 70.9171 21.4575H74.9171ZM54.0721 0.5C46.4609 0.5 39.8333 4.61038 36.1993 10.7058L39.635 12.7542C42.5859 7.80462 47.9433 4.5 54.0721 4.5V0.5ZM39.635 10.7058C36.0009 4.61038 29.3733 0.5 21.7621 0.5V4.5C27.8909 4.5 33.2483 7.80462 36.1993 12.7542L39.635 10.7058ZM21.7621 0.5C10.2387 0.5 0.917114 9.89682 0.917114 21.4575H4.91711C4.91711 12.0832 12.4705 4.5 21.7621 4.5V0.5ZM0.917114 21.4575C0.917114 34.5247 10.2261 46.5443 19.0266 55.0569C23.4837 59.3681 27.9326 62.8961 31.2637 65.345C32.9311 66.5707 34.3228 67.5294 35.3013 68.1838C35.7907 68.5111 36.1771 68.7626 36.4432 68.9335C36.5763 69.019 36.6794 69.0844 36.7503 69.1291C36.7857 69.1514 36.8131 69.1686 36.8322 69.1805C36.8418 69.1865 36.8493 69.1911 36.8546 69.1945C36.8573 69.1961 36.8595 69.1975 36.8611 69.1985C36.8619 69.199 36.8627 69.1995 36.8631 69.1997C36.8638 69.2002 36.8644 69.2005 37.9171 67.5C38.9699 65.7995 38.9701 65.7997 38.9703 65.7998C38.9702 65.7997 38.9702 65.7997 38.9699 65.7995C38.9694 65.7992 38.9684 65.7986 38.9668 65.7976C38.9637 65.7957 38.9585 65.7924 38.9513 65.7879C38.9367 65.7788 38.9139 65.7645 38.8832 65.7451C38.8216 65.7064 38.7281 65.6471 38.6049 65.5679C38.3583 65.4096 37.9927 65.1717 37.5251 64.8589C36.5896 64.2332 35.2469 63.3086 33.633 62.1222C30.4016 59.7467 26.1006 56.3344 21.8076 52.1818C13.1081 43.7669 4.91711 32.7653 4.91711 21.4575H0.917114ZM37.9171 67.5C38.9699 69.2005 38.9704 69.2002 38.9711 69.1997C38.9715 69.1995 38.9723 69.199 38.9731 69.1985C38.9748 69.1975 38.9769 69.1961 38.9796 69.1945C38.985 69.1911 38.9924 69.1865 39.002 69.1805C39.0211 69.1686 39.0485 69.1514 39.084 69.1291C39.1549 69.0844 39.2579 69.019 39.391 68.9335C39.6572 68.7626 40.0435 68.5111 40.5329 68.1838C41.5114 67.5294 42.9031 66.5707 44.5705 65.345C47.9016 62.8961 52.3506 59.3681 56.8076 55.0569C65.6081 46.5443 74.9171 34.5247 74.9171 21.4575H70.9171C70.9171 32.7653 62.7261 43.7669 54.0266 52.1818C49.7337 56.3344 45.4326 59.7467 42.2012 62.1222C40.5873 63.3086 39.2447 64.2332 38.3091 64.8589C37.8415 65.1717 37.4759 65.4096 37.2293 65.5679C37.1061 65.6471 37.0126 65.7064 36.9511 65.7451C36.9203 65.7645 36.8975 65.7788 36.883 65.7879C36.8757 65.7924 36.8705 65.7957 36.8674 65.7976C36.8658 65.7986 36.8648 65.7992 36.8643 65.7995C36.864 65.7997 36.8641 65.7997 36.8639 65.7998C36.8641 65.7997 36.8644 65.7995 37.9171 67.5Z" fill="white" mask="url(#path-1-outside-1)"/>
            </svg>
            </div>
        </transition-group>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
    name: "AnimationHeart",
   props: {
   },
   computed: {
      ...mapGetters(["listRenderAnimations"])
   },
   data: () => ({
   }),
   mounted() {},
   methods: {
       ...mapActions([
         "removeFirstLikeAnimation"
      ]),
      enterLikeTransition(el) {
         el.remove();
         this.removeFirstLikeAnimation();
      },
   },
   async beforeDestroy() {
   }
};
</script>

<style lang="scss">
$color-1: #FF9900;
$color-2: #BAA0CA;
$color-3: #EC8484;
$color-4: #B2D898;
$color-5: #FDDC78;
$color-6: #EE88BB;
$color-7: #99DDFF;

.animation-box {
   position: absolute;
   height: calc(100% - 6.4rem);
   top: 0;
   right: 0;
   width: 5rem;

   .flying-heart {
      position: absolute;
      top: calc(100% - 45px);
      right: 1.5rem;
      width: 3rem;
      z-index: 1;
      opacity: 0;
      -webkit-animation: flying-heart 3s ease forwards;
      /* Safari 4.0 - 8.0 */
      animation: flying-heart 3s ease forwards;
      svg {
         width: 35px;
         height: 32px;
      }
      &.bg-animation-1 {
         svg {
            path#solid {
               fill: $color-1;
            }
         }
      }

      &.bg-animation-2 {
         svg {
            path#solid {
               fill: $color-2;
            }
         }
      }

      &.bg-animation-3 {
         svg {
            path#solid {
               fill: $color-3;
            }
         }
      }

      &.bg-animation-4 {
         svg {
            path#solid {
               fill: $color-4;
            }
         }
      }

      &.bg-animation-5 {
         svg {
            path#solid {
               fill: $color-5;
            }
         }
      }

      &.bg-animation-6 {
         svg {
            path#solid {
               fill: $color-6;
            }
         }
      }

      &.bg-animation-7 {
         svg {
            path#solid {
               fill: $color-7;
            }
         }
      }

      &.animation-style-1 {
         -webkit-animation: flying-heart 3s ease forwards;
         /* Safari 4.0 - 8.0 */
         animation: flying-heart 3s ease forwards;
         //animation-delay: 0.5s;
      }

      &.animation-style-2 {
         -webkit-animation: flying-heart-2 3s ease-in forwards;
         /* Safari 4.0 - 8.0 */
         animation: flying-heart-2 3s ease-in forwards;
         //animation-delay: 1s;
      }

      &.animation-style-3 {
         -webkit-animation: flying-heart-3 3s ease-out forwards;
         /* Safari 4.0 - 8.0 */
         animation: flying-heart-3 3s ease-out forwards;
         //animation-delay: 1.5s;
      }
   }
}

/* Safari 4.0 - 8.0 */
@-webkit-keyframes flying-heart {
   0% {
      transform: rotate(0deg);
      opacity: 0;
   }

   25% {
      transform: rotate(15deg);
      opacity: 0.6;
      right: 3rem;
   }

   50% {
      transform: rotate(0deg);
      opacity: 0.8;
      right: 1rem;
   }

   75% {
      transform: rotate(-15deg);
      opacity: 0.6;
      right: 6rem;
   }

   100% {
      transform: rotate(0deg);
      opacity: 0;
      top: 0;
      display: none;
      right: 4rem;
   }
}

/* Standard syntax */
@keyframes flying-heart {
   0% {
      transform: rotate(0deg);
      opacity: 0;
   }

   25% {
      transform: rotate(15deg);
      opacity: 0.6;
      right: 3rem;
   }

   50% {
      transform: rotate(0deg);
      opacity: 0.8;
      right: 1rem;
   }

   75% {
      transform: rotate(-15deg);
      opacity: 0.6;
      right: 6rem;
   }

   100% {
      transform: rotate(0deg);
      opacity: 0;
      top: 0;
      display: none;
      right: 4rem;
   }
}

/* Safari 4.0 - 8.0 */
@-webkit-keyframes flying-heart-2 {
   0% {
      transform: rotate(0deg);
      opacity: 0;
   }

   25% {
      transform: rotate(30deg);
      opacity: 0.6;
      right: 6.5rem;
   }

   50% {
      transform: rotate(0deg);
      opacity: 0.8;
      right: 1.5rem;
   }

   75% {
      transform: rotate(-30deg);
      opacity: 0.6;
      right: 0;
   }

   100% {
      transform: rotate(0deg);
      opacity: 0;
      top: 0;
      display: none;
      right: 3.5rem;
   }
}

/* Standard syntax */
@keyframes flying-heart-2 {
   0% {
      transform: rotate(0deg);
      opacity: 0;
   }

   25% {
      transform: rotate(30deg);
      opacity: 0.6;
      right: 6.5rem;
   }

   50% {
      transform: rotate(0deg);
      opacity: 0.8;
      right: 1.5rem;
   }

   75% {
      transform: rotate(-30deg);
      opacity: 0.6;
      right: 0;
   }

   100% {
      transform: rotate(0deg);
      opacity: 0;
      top: 0;
      display: none;
      right: 3.5rem;
   }
}

/* Safari 4.0 - 8.0 */
@-webkit-keyframes flying-heart-3 {
   0% {
      transform: rotate(0deg);
      opacity: 0;
   }

   25% {
      transform: rotate(-15deg);
      opacity: 0.6;
      right: 0;
   }

   50% {
      transform: rotate(0deg);
      opacity: 0.8;
      right: 5rem;
   }

   75% {
      transform: rotate(15deg);
      opacity: 0.6;
      right: 2.5rem;
   }

   100% {
      transform: rotate(0deg);
      opacity: 0;
      top: 0;
      display: none;
      right: 0;
   }
}

/* Standard syntax */
@keyframes flying-heart-3 {
   0% {
      transform: rotate(0deg);
      opacity: 0;
   }

   25% {
      transform: rotate(-15deg);
      opacity: 0.6;
      right: 0;
   }

   50% {
      transform: rotate(0deg);
      opacity: 0.8;
      right: 5rem;
   }

   75% {
      transform: rotate(15deg);
      opacity: 0.6;
      right: 2.5rem;
   }

   100% {
      transform: rotate(0deg);
      opacity: 0;
      top: 0;
      display: none;
      right: 0;
   }
}
</style>

                        